module.exports = __webpack_public_path__ + "img/mobile.cbe9aa87.svg";